const ROLES = {
  OWNER: 'owner',
  ACCOUNTING_USER: 'accountingUser',
  INVOICING_USER: 'invoicingUser',
  EXPENSE_USER: 'expenseUser'
};

export default ROLES;